<template>
  <ShipmentDataTable ref="shipmentDataTable"
                     :loading="loading"
                     :shipments="shipments"
                     :shipments-total="shipmentsTotalCount"

                     :start-default-value="defaultValue.start"
                     :end-default-value="defaultValue.end"
                     :branch-default-value="defaultValue.branch"
                     :is-executor-approved-default-value="defaultValue.isExecutorApproved"
                     :is-customer-approved-default-value="defaultValue.isCustomerApproved"
                     :is-decline-default-value="defaultValue.isDeclined"
                     :search-default-value="defaultValue.search"
                     :page-default-value="defaultValue.page"
                     :limit-default-value="defaultValue.limit"
                     :sort-default-value="defaultValue.sort"
                     :desc-default-value="defaultValue.desc"
                     :has-invoice-default-value="defaultValue.hasInvoice"
                     :status-default-value="defaultValue.status"

                     @update="onUpdate"
                     @print="onPrint"
                     @excel-single="onExcelSingleDownload"
                     @excel-all="onExcelAllDownload"
  >
    <template v-slot:title>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Все поставки</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
    </template>
  </ShipmentDataTable>
</template>

<script>
import ShipmentDataTable from '@/components/DataTables/ShipmentDataTable';
import ShipmentBoxMixin from "@/views/main/shipment/box/ShipmentBoxMixin";

export default {
  name: "ShipmentAllBoxView",
  mixins: [ShipmentBoxMixin],
  components: {
    ShipmentDataTable
  }
}
</script>